import { render, staticRenderFns } from "./main-recruitment-card.vue?vue&type=template&id=366b7a58&scoped=true"
import script from "./main-recruitment-card.vue?vue&type=script&lang=js"
export * from "./main-recruitment-card.vue?vue&type=script&lang=js"
import style0 from "./main-recruitment-card.vue?vue&type=style&index=0&id=366b7a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b7a58",
  null
  
)

export default component.exports